import { MailFolder } from 'owa-graph-schema';
import { ARCHIVE_INHERIT_SUBMENU_ITEM_IDENTIFIER } from '../utils/retentionPolicyConstants';

/**
 * Utility to compare selected policy and current policy of a section in assign policy context submenu
 * @param folder the current folder
 * @param retentionId the retention id of the selected policy
 * @param inheritSubMenuIdentifier identifier to know whether the item belongs to archive or delete section
 */
export default function isSelectedPolicyDifferentForFolder(config: {
    folder: MailFolder;
    retentionId: string;
    inheritSubMenuIdentifier: string;
}): boolean {
    const { folder, retentionId, inheritSubMenuIdentifier } = config;
    const retentionTag =
        inheritSubMenuIdentifier === ARCHIVE_INHERIT_SUBMENU_ITEM_IDENTIFIER
            ? folder.ArchiveTag
            : folder.PolicyTag;
    const isTagDifferentByValue = !!retentionTag && retentionId != retentionTag.Value;
    const isTagNew = !retentionTag && retentionId != inheritSubMenuIdentifier;
    return isTagDifferentByValue || isTagNew;
}
